import {reactive, computed, watch} from 'vue';

export default function DispatchUser(data = {}) {
    // Reactive state for dispatch user fields
    const state = reactive({
        id: data.id || '',
        lastName: data.lastName || '',
        firstName: data.firstName || '',
        email: data.email || '',
        phoneNumber: data.phoneNumber || '',
        isAdminUser: data.isAdminUser || false,
    });

    // Computed properties for validations
    const validations = {
        isLastNameValid: computed(() => !!state.lastName.trim()),
        isFirstNameValid: computed(() => !!state.firstName.trim()),
        isEmailValid: computed(() => /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(state.email)),
        isPhoneNumberValid: computed(() => !state.phoneNumber || /^[+]?[(]?[0-9]{3}[)]?[-\s.]?[0-9]{3}[-\s.]?[0-9]{4,6}$/.test(state.phoneNumber))
    };

    // Individual field validation functions
    const validateLastName = () => {
        if (validations.isLastNameValid.value) {
            $('#dispatch-user-last-name-input').removeClass('is-invalid');
            $('#dispatch-user-last-name-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-last-name-input').addClass('is-invalid');
            $('#dispatch-user-last-name-error').removeClass('d-none');
            return false;
        }
    };

    const validateFirstName = () => {
        if (validations.isFirstNameValid.value) {
            $('#dispatch-user-first-name-input').removeClass('is-invalid');
            $('#dispatch-user-first-name-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-first-name-input').addClass('is-invalid');
            $('#dispatch-user-first-name-error').removeClass('d-none');
            return false;
        }
    };

    const validateEmail = () => {
        if (validations.isEmailValid.value) {
            $('#dispatch-user-email-input').removeClass('is-invalid');
            $('#dispatch-user-email-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-email-input').addClass('is-invalid');
            $('#dispatch-user-email-error').removeClass('d-none');
            return false;
        }
    };

    const validatePhoneNumber = () => {
        if (validations.isPhoneNumberValid.value) {
            $('#dispatch-user-phone-number-input').removeClass('is-invalid');
            $('#dispatch-user-phone-number-error').addClass('d-none');
            return true;
        } else {
            $('#dispatch-user-phone-number-input').addClass('is-invalid');
            $('#dispatch-user-phone-number-error').removeClass('d-none');
            return false;
        }
    };

    // Set up watchers for real-time validation
    watch(() => state.lastName, validateLastName);
    watch(() => state.firstName, validateFirstName);
    watch(() => state.email, validateEmail);
    watch(() => state.phoneNumber, validatePhoneNumber);

    // Validation logic for the entire form
    const isValid = () => {
        let isLastNameValid = validateLastName();
        let isFirstNameValid = validateFirstName();
        let isEmailValid = validateEmail();
        let isPhoneNumberValid = validatePhoneNumber();

        return isLastNameValid && isFirstNameValid && isEmailValid && isPhoneNumberValid;
    };

    const clearFields = () => {
        state.lastName = '';
        state.firstName = '';
        state.id = '';
        state.email = '';
        state.phoneNumber = '';
        state.serviceProvider = undefined;
        state.isAdminUser = false;
    };

    // Initialize validation
    const initializeValidation = () => {
        // Only validate fields that have values
        if (state.lastName) validateLastName();
        if (state.firstName) validateFirstName();
        if (state.email) validateEmail();
        if (state.phoneNumber) validatePhoneNumber();
    };

    // Call initialization after a short delay to ensure DOM is ready
    setTimeout(initializeValidation, 100);

    return {
        state,
        validations,
        isValid,
        clearFields,
        initializeValidation
    };
}
